import { ResidentMedicationsScreen } from "app/screens/residents/show/MedicationsScreen";

export default function ResidentMedicationsPage() {
  return <ResidentMedicationsScreen />;
}
